export function getTamarikiList() {
    const tamarikiMax = 20;
    const tamarikiList = [];
    let tamarikiCount = 1;
    // let tamarikiCountList = [0];

    while (tamarikiCount < tamarikiMax) {
        tamarikiList.push({
            type: "text",
            title: `Tamaiti ${tamarikiCount} Name`,
            name: `tamaiti${tamarikiCount}`,
            visibleIf: `{tamarikiCount} >= ${tamarikiCount}`,
            isRequired: true,
        });

        tamarikiList.push({
            type: "dropdown",
            title: "Gender",
            name: `tamaiti${tamarikiCount}Gender`,
            choices: ["Female", "Male"],
            visibleIf: `{tamarikiCount} >= ${tamarikiCount}`,
            isRequired: true,
        });

        tamarikiList.push({
            type: "mybootstrapdatepicker",
            inputType: "date",
            name: `tamaiti${tamarikiCount}Dob`,
            title: "Date of Birth",
            visibleIf: `{tamarikiCount} >= ${tamarikiCount}`,
            isRequired: true,
        });

        // tamarikiCountList.push(tamarikiCount);
        tamarikiCount++;
    }
    tamarikiList.unshift({
        title: "How many tamariki do you have?",
        type: "dropdown",
        name: "tamarikiCount",
        isRequired: true,
        choicesMax: tamarikiCount,
    });

    return tamarikiList;
}
